import brandPortalOrders from "@faire/web-api/routes/brand-portal/orders";
import brandPortalOrdersbrandOrderTokenEdit from "@faire/web-api/routes/brand-portal/orders/brandOrderToken/edit";
import { Button } from "@faire/web/slate/Button";
import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import { Bold } from "../common/Bold";
export var EditOrderInformationIA = function EditOrderInformationIA(_ref) {
  var _context$brandOrder, _context$brandOrder$b;
  var context = _ref.context;
  var brandOrderToken = (_context$brandOrder = context.brandOrder) === null || _context$brandOrder === void 0 ? void 0 : (_context$brandOrder$b = _context$brandOrder.brand_order) === null || _context$brandOrder$b === void 0 ? void 0 : _context$brandOrder$b.token;
  if (brandOrderToken) {
    return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "ea0MKp",
      defaultMessage: [{
        "type": 0,
        "value": "Para editar as informações da encomenda, aceda primeiro à "
      }, {
        "children": [{
          "type": 0,
          "value": "página de informações da encomenda"
        }],
        "type": 8,
        "value": "OrderDetailsLinkFormatting"
      }, {
        "type": 0,
        "value": ". Em seguida, selecione o link "
      }, {
        "children": [{
          "type": 0,
          "value": "Editar"
        }],
        "type": 8,
        "value": "LinkFormatting"
      }, {
        "type": 0,
        "value": " para alterar as informações de envio, as promoções ou os produtos."
      }],
      values: {
        LinkFormatting: function LinkFormatting(chunks) {
          return EditOrderLinkFormatting(chunks, brandOrderToken);
        },
        OrderDetailsLinkFormatting: function OrderDetailsLinkFormatting(chunks) {
          return OrderLinkFormatting(chunks);
        }
      }
    })), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "V3/NqV",
      defaultMessage: [{
        "type": 0,
        "value": "Pode editar o endereço de envio ou a data de envio clicando no ícone de caneta junto das respetivas secções. Após efetuar as alterações, clique em "
      }, {
        "children": [{
          "type": 0,
          "value": "Atualizar"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }, {
        "type": 0,
        "value": " para as guardar."
      }],
      values: {
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        }
      }
    })), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "4Xj61v",
      defaultMessage: [{
        "type": 0,
        "value": "Pode atualizar as quantidades de produtos editando os campos "
      }, {
        "children": [{
          "type": 0,
          "value": "Qtd."
        }],
        "type": 8,
        "value": "BoldFormatting"
      }, {
        "type": 0,
        "value": ". Também pode aplicar ou remover uma promoção da encomenda."
      }],
      values: {
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        }
      }
    })), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "aQBXiZ",
      defaultMessage: [{
        "type": 0,
        "value": "Quando efetuar alterações, terá a opção de deixar uma nota ao revendedor, o que recomendamos vivamente para uma experiência positiva para o cliente. O revendedor receberá uma notificação por e-mail com os detalhes das alterações efetuadas."
      }],
      values: {
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        }
      }
    })));
  } else {
    return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "XGPsSb",
      defaultMessage: [{
        "type": 0,
        "value": "Para editar as informações de uma encomenda nova ou não processada, aceda primeiro às suas "
      }, {
        "children": [{
          "type": 0,
          "value": "Encomendas"
        }],
        "type": 8,
        "value": "LinkFormatting"
      }, {
        "type": 0,
        "value": " e navegue para a "
      }, {
        "children": [{
          "type": 0,
          "value": "página de detalhes da encomenda"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }, {
        "type": 0,
        "value": " que pretende alterar. Em seguida, selecione o link "
      }, {
        "children": [{
          "type": 0,
          "value": "Editar"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }, {
        "type": 0,
        "value": " para alterar as informações de envio, as promoções ou os produtos."
      }],
      values: {
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        },
        LinkFormatting: function LinkFormatting(chunks) {
          return OrderLinkFormatting(chunks);
        }
      }
    })), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "1Bp3jy",
      defaultMessage: [{
        "type": 0,
        "value": "Pode editar o endereço de envio ou a data de envio clicando no ícone de caneta junto das respetivas secções. Após efetuar as alterações, clique em "
      }, {
        "children": [{
          "type": 0,
          "value": "Atualizar"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }, {
        "type": 0,
        "value": " para as guardar."
      }],
      values: {
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        }
      }
    })), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "AXd4P9",
      defaultMessage: [{
        "type": 0,
        "value": "Pode atualizar as quantidades de produtos editando os campos "
      }, {
        "children": [{
          "type": 0,
          "value": "Qtd."
        }],
        "type": 8,
        "value": "BoldFormatting"
      }, {
        "type": 0,
        "value": ". Também pode aplicar ou remover uma promoção da encomenda."
      }],
      values: {
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        }
      }
    })), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "yD2687",
      defaultMessage: [{
        "type": 0,
        "value": "Quando efetuar alterações, terá a opção de deixar uma nota ao revendedor, o que recomendamos vivamente para uma experiência positiva para o cliente. O revendedor receberá uma notificação por e-mail com os detalhes das alterações efetuadas."
      }],
      values: {
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        }
      }
    })));
  }
};
var EditOrderLinkFormatting = function EditOrderLinkFormatting(chunks, brandOrderToken) {
  return /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    linkTo: brandPortalOrdersbrandOrderTokenEdit(brandOrderToken),
    target: "_blank"
  }, /*#__PURE__*/React.createElement(Bold, null, chunks));
};
var OrderLinkFormatting = function OrderLinkFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    linkTo: brandPortalOrders(),
    target: "_blank"
  }, /*#__PURE__*/React.createElement(Bold, null, chunks));
};
var _BoldFormatting = function _BoldFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Bold, null, chunks);
};